import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const WaiveProviderDoc = (apiData) => async () => {
  try {
    const response = await axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/admin/provider/WaiveProviderDoc`,
      data: apiData,
    });
    return response.data;
  } catch (error) {
    return error?.response?.data || { success: false, message: error.message };
  }
};
